/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-unused-vars */
import React from "react"
import ReactDom from "react-dom/client" 
 import About from "./Pages/About.jsx"; 
 import Blog from "./Pages/Blog.jsx"; 
  import Offer from "./Pages/Offer.jsx"; 
 import Search from "./Pages/Search.jsx"; 
 import Contact from "./Pages/Contact.jsx";
   import Aboutusection from "./views/About/Aboutusection.jsx"; 
 import Jobs from "./Pages/Jobs.jsx"; 
 import Support from "./Pages/Support.jsx";
  import Terms from "./Pages/Terms.jsx";
 import Privacy from "./Pages/Privacy.jsx";
 import Home from "./Pages/Home.jsx"; 
 import { createBrowserRouter, RouterProvider } from "react-router-dom";
 import Blog1 from "./views/Blogs/Blog1.jsx";
import Blog2 from "./views/Blogs/Blog2.jsx";
import Blog3 from "./views/Blogs/Blog3.jsx";
  import Teamsection from "./views/Teams/Teamsection.jsx";
import Faq from "./Pages/Faq.jsx"; 
 import Skeletonui from "./Components/Skeletonui.jsx";
import Cardsk from "./Components/Cardsk.jsx";
 import Accounts from "./Myaccount/Accounts.jsx";  
    
 import Thanks from "./Pages/Thanks.jsx"; 
 import Construction from "./Catlog/Construction.jsx";
import Navbar from "./Navbar/Navbar.jsx";
import Sitekitthemes from "./Pages/Sitekitthemes.jsx";
import Plugins from "./Pages/Plugins.jsx";
import Whyus from "./Pages/Whyus.jsx";
import Searchanything from "./Pages/Searchanything.jsx";
import Makeup from "./Catlog/Makeup.jsx";
import Newupdates from "./Slides/Newupdates.jsx";
import Newlatestupdates from "./Pages/Newlatestupdates.jsx";
import Agriculture from "./Catlog/Agriculture.jsx";
import Blogmagazine from "./Catlog/Blogmagazine.jsx";
import Businessconsulting from "./Catlog/Businessconsulting.jsx";
import Clothingstore from "./Catlog/Clothingstore.jsx";
import Digitalmarketing from "./Catlog/Digitalmarketing.jsx";
import Hotelandresort from "./Catlog/Hotelandresort.jsx";
import Otherssites from "./Catlog/Otherssites.jsx";
import Category from "./Pages/Category.jsx";
 
const router = createBrowserRouter([ 
  {
    path: '/',
    element: <Home /> 
  }, 
  { 
    path: '/About',
    element: <About /> 
  }, 
  { 
    path: '/Category',
    element: <Category /> 
  }, 
  
   
  
  { 
    path: '/Home',
    element: <Home /> 
  }, 
  
  { 
    path: '/Faq',
    element: <Faq /> 
  }, 
  { 
    path: '/Blog',
    element: <Blog /> 
  },  
  { 
    path: '/Offer',
    element: <Offer /> 
  }, 
  { 
    path: '/Search',
    element: <Search /> 
  }, 
  { 
    path: '/Aboutusection',
    element: <Aboutusection /> 
  }, 
  { 
    path: '/Contact',
    element: <Contact /> 
  }, 
  
  { 
    path: '/Jobs',
    element: <Jobs /> 
  } ,
  { 
    path: '/Support',
    element: <Support /> 
  } ,
  
  { 
    path: '/Terms',
    element: <Terms /> 
  } ,
  { 
    path: '/Privacy',
    element: <Privacy /> 
  } ,
   
  { 
    path: '/Blog1',
    element: <Blog1 /> 
  } ,
  { 
    path: '/Blog2',
    element: <Blog2 /> 
  } ,
  
  { 
    path: '/Blog3',
    element: <Blog3 /> 
  } ,
  
  
  { 
    path: '/Makeup',
    element: <Makeup/> 
  } ,
  
  
  { 
    path: '/Searchanything',
    element: <Searchanything/> 
  } ,
  { 
    path: '/Whyus',
    element: <Whyus/> 
  } ,
  { 
    path: '/Newupdates',
    element: <Newupdates/> 
  } ,
  
  { 
    path: '/Newlatestupdates',
    element: <Newlatestupdates/> 
  } ,
  
  { 
    path: '/Agriculture',
    element: <Agriculture/> 
  } ,
  { 
    path: '/Blogmagazine',
    element: <Blogmagazine/> 
  } ,
  { 
    path: '/Businessconsulting',
    element: <Businessconsulting/> 
  } ,
  { 
    path: '/Clothingstore',
    element: <Clothingstore/> 
  } ,
  { 
    path: '/Digitalmarketing',
    element: <Digitalmarketing/> 
  } ,
  { 
    path: '/Hotelandresort',
    element: <Hotelandresort/> 
  } ,
  { 
    path: '/Otherssites',
    element: <Otherssites/> 
  } ,
  { 
    path: '/Plugins',
    element: <Plugins/> 
  } , 
     
  
 
  { 
    path: '/Teamsection',
    element: <Teamsection/> 
  } ,
   
  { 
    path: '/Cardsk',
    element: <Cardsk/> 
  } ,
   
  { 
    path: '/Accounts',
    element: <Accounts/> 
  } ,
  
  { 
    path: '/Thanks',
    element: <Thanks/> 
  } , 
  
  
 
  { 
    path: '/Navbar',
    element: <Navbar/> 
  } , 
  { 
    path: '/Construction',
    element: <Construction/> 
  } , 
  
  { 
    path: '/Sitekitthemes',
    element: <Sitekitthemes/> 
  } , 
 
  { 
    path: '/Skeletonui',
    element: <Skeletonui/> 
  }  
]);
  
ReactDom.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
  <RouterProvider router={router} />
  </React.StrictMode>
)

export default router;